/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedQuickRouteImport } from './routes/_authenticated/quick'
import { Route as SharedInviteIndexRouteImport } from './routes/_shared/invite/index'
import { Route as PublicOauthIndexRouteImport } from './routes/_public/oauth/index'
import { Route as AuthenticatedOrganizationIndexRouteImport } from './routes/_authenticated/organization/index'
import { Route as AuthenticatedOnboardingIndexRouteImport } from './routes/_authenticated/onboarding/index'
import { Route as AuthenticatedDevIndexRouteImport } from './routes/_authenticated/dev/index'
import { Route as AuthenticatedChatIndexRouteImport } from './routes/_authenticated/chat/index'
import { Route as AuthenticatedhomeIndexRouteImport } from './routes/_authenticated/(home)/index'
import { Route as PublicAuthSplatRouteImport } from './routes/_public/auth/$'
import { Route as AuthenticatedCliAuthRouteImport } from './routes/_authenticated/cli/auth'
import { Route as AuthenticatedVerifyIdentityKycIndexRouteImport } from './routes/_authenticated/verify-identity/kyc/index'
import { Route as AuthenticatedDevUsersIndexRouteImport } from './routes/_authenticated/dev/users/index'
import { Route as AuthenticatedDevBusinessIndexRouteImport } from './routes/_authenticated/dev/business/index'
import { Route as AuthenticatedDevAccountsIndexRouteImport } from './routes/_authenticated/dev/accounts/index'
import { Route as AuthenticatedChatChatIdIndexRouteImport } from './routes/_authenticated/chat/$chatId/index'
import { Route as AuthenticatedpaymentMethodsCardsCreateIndexRouteImport } from './routes/_authenticated/(payment-methods)/cards/create/index'
import { Route as AuthenticatedpaymentMethodsCardsdetailsUrnRouteImport } from './routes/_authenticated/(payment-methods)/cards/(details)/$urn'

const ExamplesCardIndexLazyRouteImport = createFileRoute('/examples/card/')()
const AuthenticatedTopUpsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/top-ups/',
)()
const AuthenticatedPersonsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/persons/',
)()
const AuthenticatedPaymentLinksIndexLazyRouteImport = createFileRoute(
  '/_authenticated/payment-links/',
)()
const AuthenticatedPaymentLinksCreateIndexLazyRouteImport = createFileRoute(
  '/_authenticated/payment-links/create/',
)()
const AuthenticatedPaymentLinksLinkIdIndexLazyRouteImport = createFileRoute(
  '/_authenticated/payment-links/$linkId/',
)()
const AuthenticatedpaymentMethodsCardsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/(payment-methods)/cards/',
)()
const AuthenticatedpaymentMethodsAccountsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/(payment-methods)/accounts/',
)()
const AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRouteImport =
  createFileRoute('/_authenticated/(payment-methods)/cards/carpet/$carpetId')()

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedQuickRoute = AuthenticatedQuickRouteImport.update({
  id: '/quick',
  path: '/quick',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ExamplesCardIndexLazyRoute = ExamplesCardIndexLazyRouteImport.update({
  id: '/examples/card/',
  path: '/examples/card/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/examples/card/index.lazy').then((d) => d.Route),
)
const AuthenticatedTopUpsIndexLazyRoute =
  AuthenticatedTopUpsIndexLazyRouteImport.update({
    id: '/top-ups/',
    path: '/top-ups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/top-ups/index.lazy').then((d) => d.Route),
  )
const AuthenticatedPersonsIndexLazyRoute =
  AuthenticatedPersonsIndexLazyRouteImport.update({
    id: '/persons/',
    path: '/persons/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/persons/index.lazy').then((d) => d.Route),
  )
const AuthenticatedPaymentLinksIndexLazyRoute =
  AuthenticatedPaymentLinksIndexLazyRouteImport.update({
    id: '/payment-links/',
    path: '/payment-links/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/payment-links/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SharedInviteIndexRoute = SharedInviteIndexRouteImport.update({
  id: '/_shared/invite/',
  path: '/invite/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicOauthIndexRoute = PublicOauthIndexRouteImport.update({
  id: '/oauth/',
  path: '/oauth/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedOrganizationIndexRoute =
  AuthenticatedOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOnboardingIndexRoute =
  AuthenticatedOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDevIndexRoute = AuthenticatedDevIndexRouteImport.update({
  id: '/dev/',
  path: '/dev/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatIndexRoute = AuthenticatedChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedhomeIndexRoute = AuthenticatedhomeIndexRouteImport.update({
  id: '/(home)/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicAuthSplatRoute = PublicAuthSplatRouteImport.update({
  id: '/auth/$',
  path: '/auth/$',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedCliAuthRoute = AuthenticatedCliAuthRouteImport.update({
  id: '/cli/auth',
  path: '/cli/auth',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPaymentLinksCreateIndexLazyRoute =
  AuthenticatedPaymentLinksCreateIndexLazyRouteImport.update({
    id: '/payment-links/create/',
    path: '/payment-links/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/payment-links/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPaymentLinksLinkIdIndexLazyRoute =
  AuthenticatedPaymentLinksLinkIdIndexLazyRouteImport.update({
    id: '/payment-links/$linkId/',
    path: '/payment-links/$linkId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/payment-links/$linkId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedpaymentMethodsCardsIndexLazyRoute =
  AuthenticatedpaymentMethodsCardsIndexLazyRouteImport.update({
    id: '/(payment-methods)/cards/',
    path: '/cards/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/(payment-methods)/cards/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedpaymentMethodsAccountsIndexLazyRoute =
  AuthenticatedpaymentMethodsAccountsIndexLazyRouteImport.update({
    id: '/(payment-methods)/accounts/',
    path: '/accounts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/(payment-methods)/accounts/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedVerifyIdentityKycIndexRoute =
  AuthenticatedVerifyIdentityKycIndexRouteImport.update({
    id: '/verify-identity/kyc/',
    path: '/verify-identity/kyc/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDevUsersIndexRoute =
  AuthenticatedDevUsersIndexRouteImport.update({
    id: '/dev/users/',
    path: '/dev/users/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDevBusinessIndexRoute =
  AuthenticatedDevBusinessIndexRouteImport.update({
    id: '/dev/business/',
    path: '/dev/business/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDevAccountsIndexRoute =
  AuthenticatedDevAccountsIndexRouteImport.update({
    id: '/dev/accounts/',
    path: '/dev/accounts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatChatIdIndexRoute =
  AuthenticatedChatChatIdIndexRouteImport.update({
    id: '/chat/$chatId/',
    path: '/chat/$chatId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedpaymentMethodsCardsCreateIndexRoute =
  AuthenticatedpaymentMethodsCardsCreateIndexRouteImport.update({
    id: '/(payment-methods)/cards/create/',
    path: '/cards/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/(payment-methods)/cards/create/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRoute =
  AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRouteImport.update({
    id: '/(payment-methods)/cards/carpet/$carpetId',
    path: '/cards/carpet/$carpetId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/(payment-methods)/cards/carpet/$carpetId.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedpaymentMethodsCardsdetailsUrnRoute =
  AuthenticatedpaymentMethodsCardsdetailsUrnRouteImport.update({
    id: '/(payment-methods)/cards/(details)/$urn',
    path: '/cards/$urn',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/quick': typeof AuthenticatedQuickRoute
  '/cli/auth': typeof AuthenticatedCliAuthRoute
  '/auth/$': typeof PublicAuthSplatRoute
  '/': typeof AuthenticatedhomeIndexRoute
  '/chat': typeof AuthenticatedChatIndexRoute
  '/dev': typeof AuthenticatedDevIndexRoute
  '/onboarding': typeof AuthenticatedOnboardingIndexRoute
  '/organization': typeof AuthenticatedOrganizationIndexRoute
  '/oauth': typeof PublicOauthIndexRoute
  '/invite': typeof SharedInviteIndexRoute
  '/payment-links': typeof AuthenticatedPaymentLinksIndexLazyRoute
  '/persons': typeof AuthenticatedPersonsIndexLazyRoute
  '/top-ups': typeof AuthenticatedTopUpsIndexLazyRoute
  '/examples/card': typeof ExamplesCardIndexLazyRoute
  '/chat/$chatId': typeof AuthenticatedChatChatIdIndexRoute
  '/dev/accounts': typeof AuthenticatedDevAccountsIndexRoute
  '/dev/business': typeof AuthenticatedDevBusinessIndexRoute
  '/dev/users': typeof AuthenticatedDevUsersIndexRoute
  '/verify-identity/kyc': typeof AuthenticatedVerifyIdentityKycIndexRoute
  '/accounts': typeof AuthenticatedpaymentMethodsAccountsIndexLazyRoute
  '/cards': typeof AuthenticatedpaymentMethodsCardsIndexLazyRoute
  '/payment-links/$linkId': typeof AuthenticatedPaymentLinksLinkIdIndexLazyRoute
  '/payment-links/create': typeof AuthenticatedPaymentLinksCreateIndexLazyRoute
  '/cards/$urn': typeof AuthenticatedpaymentMethodsCardsdetailsUrnRoute
  '/cards/carpet/$carpetId': typeof AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRoute
  '/cards/create': typeof AuthenticatedpaymentMethodsCardsCreateIndexRoute
}
export interface FileRoutesByTo {
  '/quick': typeof AuthenticatedQuickRoute
  '/cli/auth': typeof AuthenticatedCliAuthRoute
  '/auth/$': typeof PublicAuthSplatRoute
  '/': typeof AuthenticatedhomeIndexRoute
  '/chat': typeof AuthenticatedChatIndexRoute
  '/dev': typeof AuthenticatedDevIndexRoute
  '/onboarding': typeof AuthenticatedOnboardingIndexRoute
  '/organization': typeof AuthenticatedOrganizationIndexRoute
  '/oauth': typeof PublicOauthIndexRoute
  '/invite': typeof SharedInviteIndexRoute
  '/payment-links': typeof AuthenticatedPaymentLinksIndexLazyRoute
  '/persons': typeof AuthenticatedPersonsIndexLazyRoute
  '/top-ups': typeof AuthenticatedTopUpsIndexLazyRoute
  '/examples/card': typeof ExamplesCardIndexLazyRoute
  '/chat/$chatId': typeof AuthenticatedChatChatIdIndexRoute
  '/dev/accounts': typeof AuthenticatedDevAccountsIndexRoute
  '/dev/business': typeof AuthenticatedDevBusinessIndexRoute
  '/dev/users': typeof AuthenticatedDevUsersIndexRoute
  '/verify-identity/kyc': typeof AuthenticatedVerifyIdentityKycIndexRoute
  '/accounts': typeof AuthenticatedpaymentMethodsAccountsIndexLazyRoute
  '/cards': typeof AuthenticatedpaymentMethodsCardsIndexLazyRoute
  '/payment-links/$linkId': typeof AuthenticatedPaymentLinksLinkIdIndexLazyRoute
  '/payment-links/create': typeof AuthenticatedPaymentLinksCreateIndexLazyRoute
  '/cards/$urn': typeof AuthenticatedpaymentMethodsCardsdetailsUrnRoute
  '/cards/carpet/$carpetId': typeof AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRoute
  '/cards/create': typeof AuthenticatedpaymentMethodsCardsCreateIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/quick': typeof AuthenticatedQuickRoute
  '/_authenticated/cli/auth': typeof AuthenticatedCliAuthRoute
  '/_public/auth/$': typeof PublicAuthSplatRoute
  '/_authenticated/(home)/': typeof AuthenticatedhomeIndexRoute
  '/_authenticated/chat/': typeof AuthenticatedChatIndexRoute
  '/_authenticated/dev/': typeof AuthenticatedDevIndexRoute
  '/_authenticated/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/_authenticated/organization/': typeof AuthenticatedOrganizationIndexRoute
  '/_public/oauth/': typeof PublicOauthIndexRoute
  '/_shared/invite/': typeof SharedInviteIndexRoute
  '/_authenticated/payment-links/': typeof AuthenticatedPaymentLinksIndexLazyRoute
  '/_authenticated/persons/': typeof AuthenticatedPersonsIndexLazyRoute
  '/_authenticated/top-ups/': typeof AuthenticatedTopUpsIndexLazyRoute
  '/examples/card/': typeof ExamplesCardIndexLazyRoute
  '/_authenticated/chat/$chatId/': typeof AuthenticatedChatChatIdIndexRoute
  '/_authenticated/dev/accounts/': typeof AuthenticatedDevAccountsIndexRoute
  '/_authenticated/dev/business/': typeof AuthenticatedDevBusinessIndexRoute
  '/_authenticated/dev/users/': typeof AuthenticatedDevUsersIndexRoute
  '/_authenticated/verify-identity/kyc/': typeof AuthenticatedVerifyIdentityKycIndexRoute
  '/_authenticated/(payment-methods)/accounts/': typeof AuthenticatedpaymentMethodsAccountsIndexLazyRoute
  '/_authenticated/(payment-methods)/cards/': typeof AuthenticatedpaymentMethodsCardsIndexLazyRoute
  '/_authenticated/payment-links/$linkId/': typeof AuthenticatedPaymentLinksLinkIdIndexLazyRoute
  '/_authenticated/payment-links/create/': typeof AuthenticatedPaymentLinksCreateIndexLazyRoute
  '/_authenticated/(payment-methods)/cards/(details)/$urn': typeof AuthenticatedpaymentMethodsCardsdetailsUrnRoute
  '/_authenticated/(payment-methods)/cards/carpet/$carpetId': typeof AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRoute
  '/_authenticated/(payment-methods)/cards/create/': typeof AuthenticatedpaymentMethodsCardsCreateIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/quick'
    | '/cli/auth'
    | '/auth/$'
    | '/'
    | '/chat'
    | '/dev'
    | '/onboarding'
    | '/organization'
    | '/oauth'
    | '/invite'
    | '/payment-links'
    | '/persons'
    | '/top-ups'
    | '/examples/card'
    | '/chat/$chatId'
    | '/dev/accounts'
    | '/dev/business'
    | '/dev/users'
    | '/verify-identity/kyc'
    | '/accounts'
    | '/cards'
    | '/payment-links/$linkId'
    | '/payment-links/create'
    | '/cards/$urn'
    | '/cards/carpet/$carpetId'
    | '/cards/create'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/quick'
    | '/cli/auth'
    | '/auth/$'
    | '/'
    | '/chat'
    | '/dev'
    | '/onboarding'
    | '/organization'
    | '/oauth'
    | '/invite'
    | '/payment-links'
    | '/persons'
    | '/top-ups'
    | '/examples/card'
    | '/chat/$chatId'
    | '/dev/accounts'
    | '/dev/business'
    | '/dev/users'
    | '/verify-identity/kyc'
    | '/accounts'
    | '/cards'
    | '/payment-links/$linkId'
    | '/payment-links/create'
    | '/cards/$urn'
    | '/cards/carpet/$carpetId'
    | '/cards/create'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/quick'
    | '/_authenticated/cli/auth'
    | '/_public/auth/$'
    | '/_authenticated/(home)/'
    | '/_authenticated/chat/'
    | '/_authenticated/dev/'
    | '/_authenticated/onboarding/'
    | '/_authenticated/organization/'
    | '/_public/oauth/'
    | '/_shared/invite/'
    | '/_authenticated/payment-links/'
    | '/_authenticated/persons/'
    | '/_authenticated/top-ups/'
    | '/examples/card/'
    | '/_authenticated/chat/$chatId/'
    | '/_authenticated/dev/accounts/'
    | '/_authenticated/dev/business/'
    | '/_authenticated/dev/users/'
    | '/_authenticated/verify-identity/kyc/'
    | '/_authenticated/(payment-methods)/accounts/'
    | '/_authenticated/(payment-methods)/cards/'
    | '/_authenticated/payment-links/$linkId/'
    | '/_authenticated/payment-links/create/'
    | '/_authenticated/(payment-methods)/cards/(details)/$urn'
    | '/_authenticated/(payment-methods)/cards/carpet/$carpetId'
    | '/_authenticated/(payment-methods)/cards/create/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  SharedInviteIndexRoute: typeof SharedInviteIndexRoute
  ExamplesCardIndexLazyRoute: typeof ExamplesCardIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/quick': {
      id: '/_authenticated/quick'
      path: '/quick'
      fullPath: '/quick'
      preLoaderRoute: typeof AuthenticatedQuickRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/examples/card/': {
      id: '/examples/card/'
      path: '/examples/card'
      fullPath: '/examples/card'
      preLoaderRoute: typeof ExamplesCardIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/top-ups/': {
      id: '/_authenticated/top-ups/'
      path: '/top-ups'
      fullPath: '/top-ups'
      preLoaderRoute: typeof AuthenticatedTopUpsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/': {
      id: '/_authenticated/persons/'
      path: '/persons'
      fullPath: '/persons'
      preLoaderRoute: typeof AuthenticatedPersonsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payment-links/': {
      id: '/_authenticated/payment-links/'
      path: '/payment-links'
      fullPath: '/payment-links'
      preLoaderRoute: typeof AuthenticatedPaymentLinksIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_shared/invite/': {
      id: '/_shared/invite/'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof SharedInviteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/oauth/': {
      id: '/_public/oauth/'
      path: '/oauth'
      fullPath: '/oauth'
      preLoaderRoute: typeof PublicOauthIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/organization/': {
      id: '/_authenticated/organization/'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthenticatedOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding/': {
      id: '/_authenticated/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dev/': {
      id: '/_authenticated/dev/'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof AuthenticatedDevIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat/': {
      id: '/_authenticated/chat/'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthenticatedChatIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(home)/': {
      id: '/_authenticated/(home)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedhomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/auth/$': {
      id: '/_public/auth/$'
      path: '/auth/$'
      fullPath: '/auth/$'
      preLoaderRoute: typeof PublicAuthSplatRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/cli/auth': {
      id: '/_authenticated/cli/auth'
      path: '/cli/auth'
      fullPath: '/cli/auth'
      preLoaderRoute: typeof AuthenticatedCliAuthRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payment-links/create/': {
      id: '/_authenticated/payment-links/create/'
      path: '/payment-links/create'
      fullPath: '/payment-links/create'
      preLoaderRoute: typeof AuthenticatedPaymentLinksCreateIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payment-links/$linkId/': {
      id: '/_authenticated/payment-links/$linkId/'
      path: '/payment-links/$linkId'
      fullPath: '/payment-links/$linkId'
      preLoaderRoute: typeof AuthenticatedPaymentLinksLinkIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(payment-methods)/cards/': {
      id: '/_authenticated/(payment-methods)/cards/'
      path: '/cards'
      fullPath: '/cards'
      preLoaderRoute: typeof AuthenticatedpaymentMethodsCardsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(payment-methods)/accounts/': {
      id: '/_authenticated/(payment-methods)/accounts/'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AuthenticatedpaymentMethodsAccountsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/verify-identity/kyc/': {
      id: '/_authenticated/verify-identity/kyc/'
      path: '/verify-identity/kyc'
      fullPath: '/verify-identity/kyc'
      preLoaderRoute: typeof AuthenticatedVerifyIdentityKycIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dev/users/': {
      id: '/_authenticated/dev/users/'
      path: '/dev/users'
      fullPath: '/dev/users'
      preLoaderRoute: typeof AuthenticatedDevUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dev/business/': {
      id: '/_authenticated/dev/business/'
      path: '/dev/business'
      fullPath: '/dev/business'
      preLoaderRoute: typeof AuthenticatedDevBusinessIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dev/accounts/': {
      id: '/_authenticated/dev/accounts/'
      path: '/dev/accounts'
      fullPath: '/dev/accounts'
      preLoaderRoute: typeof AuthenticatedDevAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat/$chatId/': {
      id: '/_authenticated/chat/$chatId/'
      path: '/chat/$chatId'
      fullPath: '/chat/$chatId'
      preLoaderRoute: typeof AuthenticatedChatChatIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(payment-methods)/cards/create/': {
      id: '/_authenticated/(payment-methods)/cards/create/'
      path: '/cards/create'
      fullPath: '/cards/create'
      preLoaderRoute: typeof AuthenticatedpaymentMethodsCardsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(payment-methods)/cards/carpet/$carpetId': {
      id: '/_authenticated/(payment-methods)/cards/carpet/$carpetId'
      path: '/cards/carpet/$carpetId'
      fullPath: '/cards/carpet/$carpetId'
      preLoaderRoute: typeof AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(payment-methods)/cards/(details)/$urn': {
      id: '/_authenticated/(payment-methods)/cards/(details)/$urn'
      path: '/cards/$urn'
      fullPath: '/cards/$urn'
      preLoaderRoute: typeof AuthenticatedpaymentMethodsCardsdetailsUrnRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedQuickRoute: typeof AuthenticatedQuickRoute
  AuthenticatedCliAuthRoute: typeof AuthenticatedCliAuthRoute
  AuthenticatedhomeIndexRoute: typeof AuthenticatedhomeIndexRoute
  AuthenticatedChatIndexRoute: typeof AuthenticatedChatIndexRoute
  AuthenticatedDevIndexRoute: typeof AuthenticatedDevIndexRoute
  AuthenticatedOnboardingIndexRoute: typeof AuthenticatedOnboardingIndexRoute
  AuthenticatedOrganizationIndexRoute: typeof AuthenticatedOrganizationIndexRoute
  AuthenticatedPaymentLinksIndexLazyRoute: typeof AuthenticatedPaymentLinksIndexLazyRoute
  AuthenticatedPersonsIndexLazyRoute: typeof AuthenticatedPersonsIndexLazyRoute
  AuthenticatedTopUpsIndexLazyRoute: typeof AuthenticatedTopUpsIndexLazyRoute
  AuthenticatedChatChatIdIndexRoute: typeof AuthenticatedChatChatIdIndexRoute
  AuthenticatedDevAccountsIndexRoute: typeof AuthenticatedDevAccountsIndexRoute
  AuthenticatedDevBusinessIndexRoute: typeof AuthenticatedDevBusinessIndexRoute
  AuthenticatedDevUsersIndexRoute: typeof AuthenticatedDevUsersIndexRoute
  AuthenticatedVerifyIdentityKycIndexRoute: typeof AuthenticatedVerifyIdentityKycIndexRoute
  AuthenticatedpaymentMethodsAccountsIndexLazyRoute: typeof AuthenticatedpaymentMethodsAccountsIndexLazyRoute
  AuthenticatedpaymentMethodsCardsIndexLazyRoute: typeof AuthenticatedpaymentMethodsCardsIndexLazyRoute
  AuthenticatedPaymentLinksLinkIdIndexLazyRoute: typeof AuthenticatedPaymentLinksLinkIdIndexLazyRoute
  AuthenticatedPaymentLinksCreateIndexLazyRoute: typeof AuthenticatedPaymentLinksCreateIndexLazyRoute
  AuthenticatedpaymentMethodsCardsdetailsUrnRoute: typeof AuthenticatedpaymentMethodsCardsdetailsUrnRoute
  AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRoute: typeof AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRoute
  AuthenticatedpaymentMethodsCardsCreateIndexRoute: typeof AuthenticatedpaymentMethodsCardsCreateIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedQuickRoute: AuthenticatedQuickRoute,
  AuthenticatedCliAuthRoute: AuthenticatedCliAuthRoute,
  AuthenticatedhomeIndexRoute: AuthenticatedhomeIndexRoute,
  AuthenticatedChatIndexRoute: AuthenticatedChatIndexRoute,
  AuthenticatedDevIndexRoute: AuthenticatedDevIndexRoute,
  AuthenticatedOnboardingIndexRoute: AuthenticatedOnboardingIndexRoute,
  AuthenticatedOrganizationIndexRoute: AuthenticatedOrganizationIndexRoute,
  AuthenticatedPaymentLinksIndexLazyRoute:
    AuthenticatedPaymentLinksIndexLazyRoute,
  AuthenticatedPersonsIndexLazyRoute: AuthenticatedPersonsIndexLazyRoute,
  AuthenticatedTopUpsIndexLazyRoute: AuthenticatedTopUpsIndexLazyRoute,
  AuthenticatedChatChatIdIndexRoute: AuthenticatedChatChatIdIndexRoute,
  AuthenticatedDevAccountsIndexRoute: AuthenticatedDevAccountsIndexRoute,
  AuthenticatedDevBusinessIndexRoute: AuthenticatedDevBusinessIndexRoute,
  AuthenticatedDevUsersIndexRoute: AuthenticatedDevUsersIndexRoute,
  AuthenticatedVerifyIdentityKycIndexRoute:
    AuthenticatedVerifyIdentityKycIndexRoute,
  AuthenticatedpaymentMethodsAccountsIndexLazyRoute:
    AuthenticatedpaymentMethodsAccountsIndexLazyRoute,
  AuthenticatedpaymentMethodsCardsIndexLazyRoute:
    AuthenticatedpaymentMethodsCardsIndexLazyRoute,
  AuthenticatedPaymentLinksLinkIdIndexLazyRoute:
    AuthenticatedPaymentLinksLinkIdIndexLazyRoute,
  AuthenticatedPaymentLinksCreateIndexLazyRoute:
    AuthenticatedPaymentLinksCreateIndexLazyRoute,
  AuthenticatedpaymentMethodsCardsdetailsUrnRoute:
    AuthenticatedpaymentMethodsCardsdetailsUrnRoute,
  AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRoute:
    AuthenticatedpaymentMethodsCardsCarpetCarpetIdLazyRoute,
  AuthenticatedpaymentMethodsCardsCreateIndexRoute:
    AuthenticatedpaymentMethodsCardsCreateIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicAuthSplatRoute: typeof PublicAuthSplatRoute
  PublicOauthIndexRoute: typeof PublicOauthIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAuthSplatRoute: PublicAuthSplatRoute,
  PublicOauthIndexRoute: PublicOauthIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  SharedInviteIndexRoute: SharedInviteIndexRoute,
  ExamplesCardIndexLazyRoute: ExamplesCardIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
